/**
 *
 * @param {string} email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  if (regex.test(email)) {
    return true
  }
  return false
}
